<template>
    <section id="maintenance" class="maintenance-area pt-100 pb-70">
        <div class="container">
            <!-- Cabecera -->
            <div class="one-section-title text-center">
                <span class="sub-title">Mantenimiento mensual de impresoras de gran formato</span>
                <h2>Contrata tu plan de mantenimiento con Plotix</h2>
                <p class="lead">
                    Mantén tus equipos siempre listos con un servicio preventivo y correctivo, pensado para
                    reducir paradas, alargar la vida útil y asegurar una calidad de impresión constante.
                    Nos encargamos del cuidado técnico periódico para que tú te centres en producir.
                </p>
            </div>

            <!-- Beneficios -->
            <div class="row g-4 benefits">
                <div class="col-sm-6 col-lg-3" v-for="(b, i) in benefits" :key="i">
                    <div class="benefit-card">
                        <i :class="b.icon"></i>
                        <h4>{{ b.title }}</h4>
                        <p>{{ b.text }}</p>
                    </div>
                </div>
            </div>

            <!-- CTA -->


            <!-- Condiciones -->
            <div class="accordion">
                <h3 class="text-center mb-3">Condiciones del servicio</h3>

                <details v-for="(cond, i) in conditions" :key="i">
                    <summary>{{ cond.title }}</summary>
                    <div class="acc-body" v-html="cond.content"></div>
                </details>
            </div>

            <!-- CTA inferior -->
            <div class="cta-wrap">
                <a class="cmn-banner-btn" href="tel:+34623615128">
                    <i class='bx bx-phone'></i> Hablar ahora
                </a>
                <a class="banner-right-btn" href="#contact-strip">
                    <i class='bx bx-send'></i> Solicitar propuesta
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'MaintenancePlan',
    data() {
        return {
            benefits: [
                { icon: 'bx bx-shield-quarter', title: 'Preventivo programado', text: 'Limpiezas, calibraciones y chequeos mensuales para prevenir averías.' },
                { icon: 'bx bx-time-five', title: 'Respuesta prioritaria', text: 'Atención preferente en incidencias y reducción del tiempo de parada.' },
                { icon: 'bx bx-map-pin', title: 'Movilidad incluida', text: 'Desplazamiento sin coste en Málaga–Fuengirola–Marbella. Fuera, plus por km.' },
                { icon: 'bx bx-wrench', title: 'Soporte experto', text: 'Técnicos especializados en impresión digital de gran formato.' },
            ],
            conditions: [
                {
                    title: '1. Alcance del servicio',
                    content: `
      El servicio de mantenimiento cubre exclusivamente las impresoras de gran formato registradas en el contrato,
      propiedad o bajo responsabilidad del cliente. 
      Incluye tareas de <b>prevención, diagnóstico y ajuste básico</b> orientadas a mantener la operatividad del equipo.
      No se trata de un seguro de reparación total, sino de un plan de mantenimiento técnico periódico. <br><br>
      Plotix podrá <b>interrumpir o posponer el servicio</b> si se detectan condiciones inseguras, manipulación indebida,
      instalación incorrecta o falta de suministro eléctrico adecuado. 
      Cualquier intervención fuera del alcance preventivo se presupuestará por separado.
    `
                },
                {
                    title: '2. Mantenimiento preventivo y correctivo',
                    content: `
      <ul>
        <li><b>Preventivo mensual:</b> limpieza de carro y guías, revisión de correas, ventiladores, sensores, conexiones,
        comprobación de calibraciones, test de inyectores y ajustes menores para asegurar calidad de impresión y
        reducir averías.</li>
        <li><b>Correctivo:</b> diagnóstico y resolución de fallos operativos que no requieran sustitución de piezas mayores.
        En caso de necesitar repuestos, se comunicará presupuesto previo antes de proceder.</li>
        <li><b>Diagnóstico inicial:</b> si el equipo presenta fallos graves o averías previas al alta, se realizará
        una <b>puesta a punto inicial</b> (presupuesto aparte) antes de activar la cobertura mensual.</li>
        <li><b>No incluye:</b> reinstalaciones, configuraciones de software RIP, redes, PC ni calibraciones de color
        avanzadas, salvo contratación adicional.</li>
      </ul>
    `
                },
                {
                    title: '3. Desplazamientos y zonas',
                    content: `
      La cobertura de movilidad está incluida sin coste dentro del área de <b>Málaga, Fuengirola y Marbella</b>.
      Para zonas fuera de este radio se aplicará un <b>suplemento por kilometraje</b> (ida y vuelta) y, en su caso,
      dietas por desplazamientos de larga distancia. <br><br>
      Las intervenciones se realizarán bajo cita previa, dentro del horario laboral establecido, 
      y estarán sujetas a disponibilidad del personal técnico. 
      En caso de condiciones meteorológicas adversas o fuerza mayor, las citas podrán reprogramarse sin penalización.
    `
                },
                {
                    title: '4. Condiciones económicas y facturación',
                    content: `
      La cuota del plan de mantenimiento es <b>mensual y por equipo</b>, facturada por adelantado y pagadera mediante
      domiciliación o transferencia bancaria dentro de los <b>5 días posteriores a la emisión</b>. 
      La falta de pago suspenderá automáticamente la cobertura hasta regularización. <br><br>
      Los repuestos, desplazamientos fuera de zona y servicios no incluidos se facturan aparte previa aceptación
      por parte del cliente. 
      Los precios no incluyen impuestos y podrán ser actualizados anualmente previo aviso. 
      La cancelación deberá comunicarse por escrito con <b>15 días de antelación</b> al siguiente ciclo mensual.
    `
                },
                {
                    title: '5. Garantía y exclusiones',
                    content: `
      Las intervenciones realizadas por Plotix cuentan con una <b>garantía de 30 días</b> sobre la misma incidencia y
      únicamente en los componentes o ajustes intervenidos. <br><br>
      Quedan excluidos de garantía los fallos derivados de:
      <ul>
        <li>Uso indebido del equipo, manipulación por terceros o falta de mantenimiento adecuado.</li>
        <li>Instalaciones eléctricas defectuosas, humedad, polvo excesivo, golpes o descargas eléctricas.</li>
        <li>Utilización de tintas o consumibles no recomendados, caducados o de procedencia desconocida.</li>
        <li>Actualizaciones de firmware, software o modificaciones no autorizadas por Plotix.</li>
      </ul>
      En ningún caso Plotix será responsable por <b>lucro cesante, pérdida de producción o datos</b>.
      La responsabilidad máxima se limita al importe mensual abonado por el servicio en el mes del incidente.
    `
                }
            ],
        };
    },
};
</script>

<style scoped>
:root {
    --main-color: #ff8a00;
}

.maintenance-area {
    position: relative;
    background: #0f0f10 url('@/assets/img/resources/address-bg.png') no-repeat center center;
    background-size: cover;
    color: #fff;
    z-index: 1;
}

.maintenance-area::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 15, 16, 0.45);
    z-index: -1;
}

/* Cabecera */
.one-section-title .sub-title {
    color: #ffc48a;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 700;
    margin-bottom: 8px;
}

.one-section-title h2 {
    color: #fff;
    font-weight: 800;
    margin-bottom: 10px;
}

.maintenance-area .lead {
    max-width: 920px;
    margin: 0 auto 20px;
    color: #d4d6db;
}

/* Beneficios */
.benefit-card {
    background: rgba(26, 26, 29, 0.95);
    border: 1px solid #2a2a2f;
    border-radius: 12px;
    padding: 22px;
    height: 100%;
    color: #eee;
    text-align: left;
    transition: 0.25s ease;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .25);
}

.benefit-card:hover {
    border-color: var(--main-color);
    transform: translateY(-3px);
}

.benefit-card i {
    font-size: 30px;
    color: var(--main-color);
    margin-bottom: 8px;
}

.benefit-card h4 {
    margin-bottom: 6px;
    color: #fff;
    font-weight: 700;
}

.benefit-card p {
    color: #ccc;
    margin: 0;
}

/* CTA */
.cta-wrap {
    display: flex;
    gap: 14px;
    justify-content: center;
    margin: 28px 0 18px;
    flex-wrap: wrap;
}

.cmn-banner-btn,
.banner-right-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 10px;
    font-weight: 700;
    transition: all 0.3s ease;
}

.cmn-banner-btn {
    background: var(--main-color);
    color: #0f0f10;
    box-shadow: 0 6px 18px rgba(255, 138, 0, 0.3);
}

.cmn-banner-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 24px rgba(255, 138, 0, 0.4);
}

.banner-right-btn {
    border: 1px solid #444;
    background: rgba(26, 26, 29, 0.85);
    color: #fff;
}

.banner-right-btn:hover {
    border-color: var(--main-color);
    color: #fff;
}

/* Accordion */
.accordion {
    max-width: 980px;
    margin: 24px auto 0;
}

.accordion h3 {
    color: #fff;
    font-weight: 800;
}

.accordion details {
    background: rgba(18, 18, 20, 0.9);
    border: 1px solid #2a2a2f;
    border-radius: 10px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
}

.accordion details[open] {
    border-color: var(--main-color);
}

.accordion summary {
    cursor: pointer;
    list-style: none;
    padding: 16px 18px;
    font-weight: 700;
    color: #fff;
    position: relative;
}

.accordion summary::after {
    content: '+';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--main-color);
    font-weight: 900;
}

.accordion details[open] summary::after {
    content: '–';
}

.acc-body {
    padding: 0 18px 16px;
    color: #ddd;
    line-height: 1.65;
}

.acc-body ul {
    padding-left: 18px;
    margin: 0;
}

/* Responsive */
@media (max-width: 767px) {
    .benefit-card {
        text-align: center;
    }

    .acc-body {
        font-size: 15px;
    }
}
</style>
